import { initLazyLoad } from "@opportunus-lib-js/lazy-load/lazy-load";

$(document).ready(function() {
    initLazyLoad('snippet-dealerLazyLoading-showStoresSnippet', 'loadMoreStores', 'dealer-lazyloading-placeholder');
});
